import React from "react";

export default () => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15.463 7.5H3.63C1.953 7.5.5 8.848.5 10.512v4.963c0 1.664 1.453 3.025 3.13 3.025h.87v2.948c0 .649.653.993 1.132.551l3.68-3.499h6.151a3.037 3.037 0 0 0 3.037-3.025v-4.963c0-1.664-1.362-3.012-3.037-3.012zm5.237 5.003c1.534-.173 2.8-1.473 2.8-3.054V5.575c0-1.698-1.524-3.075-3.223-3.075h-9.852c-1.6 0-2.756 1.222-2.904 2.782M4.517 14.5h9.914m-9.914-3h9.914"
      stroke="white"
      strokeLinecap="square"
      fill="none"
      fillRule="evenodd"
    />
  </svg>
);
